/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChatRequestDto,
  ChatbotConversationResponseDto,
  ErrorResponse,
  PaginatedMessagesResponseDto,
  SSEEventDto,
  UpdateConversationTitleDto,
} from '../models/index';
import {
    ChatRequestDtoFromJSON,
    ChatRequestDtoToJSON,
    ChatbotConversationResponseDtoFromJSON,
    ChatbotConversationResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PaginatedMessagesResponseDtoFromJSON,
    PaginatedMessagesResponseDtoToJSON,
    SSEEventDtoFromJSON,
    SSEEventDtoToJSON,
    UpdateConversationTitleDtoFromJSON,
    UpdateConversationTitleDtoToJSON,
} from '../models/index';

export interface ChatBotRequest {
    chatRequestDto: ChatRequestDto;
}

export interface ChatbotDeleteConversationRequest {
    conversationId: string;
}

export interface ChatbotGetMessagesRequest {
    conversationId: string;
    nextPageToken?: string;
    pageSize?: number;
}

export interface ChatbotUpdateTitleRequest {
    conversationId: string;
    updateConversationTitleDto: UpdateConversationTitleDto;
}

/**
 * 
 */
export class ChatbotApi extends runtime.BaseAPI {

    /**
     * Supports SSE streaming (Accept: text/event-stream) for real-time chat responses with file attachments (images, documents, audio, video)
     * Send message with optional files to Gemini 2.5 Pro chatbot
     */
    async chatBotRaw(requestParameters: ChatBotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SSEEventDto>> {
        if (requestParameters['chatRequestDto'] == null) {
            throw new runtime.RequiredError(
                'chatRequestDto',
                'Required parameter "chatRequestDto" was null or undefined when calling chatBot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/chat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatRequestDtoToJSON(requestParameters['chatRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SSEEventDtoFromJSON(jsonValue));
    }

    /**
     * Supports SSE streaming (Accept: text/event-stream) for real-time chat responses with file attachments (images, documents, audio, video)
     * Send message with optional files to Gemini 2.5 Pro chatbot
     */
    async chatBot(requestParameters: ChatBotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SSEEventDto> {
        const response = await this.chatBotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a specific conversation and all its messages
     * Delete conversation
     */
    async chatbotDeleteConversationRaw(requestParameters: ChatbotDeleteConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling chatbotDeleteConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/conversations/{conversationId}`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters['conversationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a specific conversation and all its messages
     * Delete conversation
     */
    async chatbotDeleteConversation(requestParameters: ChatbotDeleteConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatbotDeleteConversationRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve all conversations for the authenticated user
     * Get user\'s conversations
     */
    async chatbotGetConversationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatbotConversationResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/conversations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatbotConversationResponseDtoFromJSON));
    }

    /**
     * Retrieve all conversations for the authenticated user
     * Get user\'s conversations
     */
    async chatbotGetConversations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatbotConversationResponseDto>> {
        const response = await this.chatbotGetConversationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve paginated messages from a specific conversation
     * Get conversation messages with pagination
     */
    async chatbotGetMessagesRaw(requestParameters: ChatbotGetMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedMessagesResponseDto>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling chatbotGetMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/conversations/{conversationId}/messages`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters['conversationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedMessagesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve paginated messages from a specific conversation
     * Get conversation messages with pagination
     */
    async chatbotGetMessages(requestParameters: ChatbotGetMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedMessagesResponseDto> {
        const response = await this.chatbotGetMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the title of a specific conversation. If no title is provided, generates one based on the first user message.
     * Update or generate conversation title
     */
    async chatbotUpdateTitleRaw(requestParameters: ChatbotUpdateTitleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatbotConversationResponseDto>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling chatbotUpdateTitle().'
            );
        }

        if (requestParameters['updateConversationTitleDto'] == null) {
            throw new runtime.RequiredError(
                'updateConversationTitleDto',
                'Required parameter "updateConversationTitleDto" was null or undefined when calling chatbotUpdateTitle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/conversations/{conversationId}`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters['conversationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateConversationTitleDtoToJSON(requestParameters['updateConversationTitleDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatbotConversationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update the title of a specific conversation. If no title is provided, generates one based on the first user message.
     * Update or generate conversation title
     */
    async chatbotUpdateTitle(requestParameters: ChatbotUpdateTitleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatbotConversationResponseDto> {
        const response = await this.chatbotUpdateTitleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
